
import store from "../../redux/store";
import { boundFetchTranslatedList } from "../../redux/actions/translated_list";

const { language } = store.getState();
let currentValue = language;

const languageHandler = () => {
    let previousValue = currentValue;
    currentValue = store.getState().language;
    
    if (currentValue !== previousValue && currentValue !== 'en') {
        boundFetchTranslatedList();
    }
};

export default languageHandler;